import { render, staticRenderFns } from "./NewsSearchBar.vue?vue&type=template&id=a25add68&scoped=true&"
import script from "./NewsSearchBar.vue?vue&type=script&lang=js&"
export * from "./NewsSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./NewsSearchBar.vue?vue&type=style&index=0&id=a25add68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25add68",
  null
  
)

export default component.exports